import PropTypes from 'prop-types';
import Currency from './Currency';

CapitalValue.propTypes = {
  capitalValue: PropTypes.number,
  styles: PropTypes.object,
  isSingleLine: PropTypes.bool,
};

export default function CapitalValue({capitalValue, styles, isSingleLine = true}) {
  return (
    <div className="capital-value" style={{...styles}}>
      <strong style={{marginRight: 10}}>Capital Value</strong>
      {!isSingleLine && <br/>}
      <Currency currency={capitalValue}/>
    </div>
  );
}